import SectionLabel from "@/components/base/SectionLabel";
import { notesData } from "@/mocks/homeData";

export default function NotesSection() {
  return (
    <section id="notes" className="py-16 md:py-24 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-8">
        <div className="text-center mb-10 md:mb-12 reveal">
          <SectionLabel label={notesData.label} className="mb-3" />
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900 mb-3 md:mb-4">
            {notesData.title}
          </h2>
          <p className="text-sm md:text-base text-foreground-700 max-w-xl mx-auto">
            {notesData.description}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          {notesData.items.map((item, idx) => (
            <article
              key={item.title}
              className="reveal group p-5 md:p-6 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-300/60 transition-all duration-300 cursor-pointer"
              style={{ transitionDelay: `${idx * 100}ms` }}
            >
              <div className="flex items-center gap-2 mb-3">
                <span className="inline-block px-2 py-0.5 rounded bg-primary-100 text-primary-700 text-xs font-medium font-label">
                  {item.category}
                </span>
                <span className="text-xs text-foreground-500 font-label">
                  {item.date}
                </span>
              </div>
              <h3 className="text-base md:text-lg font-bold text-foreground-900 mb-3 font-heading leading-snug group-hover:text-primary-700 transition-colors">
                {item.title}
              </h3>
              <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                {item.summary}
              </p>
              <div className="flex flex-wrap gap-1.5">
                {item.tags.map((tag) => (
                  <span
                    key={tag}
                    className="inline-block px-2 py-0.5 rounded bg-secondary-100 text-secondary-800 text-xs font-medium"
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </article>
          ))}
        </div>

        <div className="text-center mt-10 md:mt-12 reveal">
          <a
            href="/notes"
            className="inline-flex items-center gap-1.5 text-sm md:text-base font-medium text-primary-600 hover:text-primary-700 transition-colors cursor-pointer"
          >
            DX・AI活用ノートをもっと見る
            <i className="ri-arrow-right-line" />
          </a>
        </div>
      </div>
    </section>
  );
}